import { z } from "zod";
// Transaction status enum
export const TransactionStatusEnum = z.enum([
    "COMPLETED",
    "PENDING",
    "CANCELED",
    "REFUNDED",
]);
// Transaction type enum
export const TransactionTypeEnum = z.enum([
    "COURSE_PURCHASE",
    "SUBSCRIPTION",
    "REFUND",
    "CREDIT",
]);
// Transaction schema
export const TransactionSchema = z.object({
    id: z.number(),
    user_uid: z.string(),
    user_name: z.string().nullable(),
    user_email: z.string().email().nullable(),
    amount: z.number(),
    currency: z.string().default("USD"),
    status: TransactionStatusEnum,
    type: TransactionTypeEnum,
    description: z.string().nullable(),
    // Related entities
    course_id: z.number().nullable().optional(),
    course_name: z.string().nullable().optional(),
    // Stripe
    stripe_payment_intent_id: z.string().nullable().optional(),
    // Invoice
    invoice_number: z.string().nullable(),
    invoice_url: z.string().nullable().optional(),
    // Timestamps
    created_at: z.date(),
    updated_at: z.date(),
});
// Transaction payload for creating
export const TransactionPayloadSchema = z.object({
    user_uid: z.string(),
    user_name: z.string().nullable().optional(),
    user_email: z.string().email().nullable().optional(),
    amount: z.number(),
    currency: z.string().optional(),
    status: TransactionStatusEnum.optional(),
    type: TransactionTypeEnum,
    description: z.string().nullable().optional(),
    course_id: z.number().nullable().optional(),
    course_name: z.string().nullable().optional(),
    stripe_payment_intent_id: z.string().nullable().optional(),
});
// Transaction filters
export const TransactionFiltersSchema = z.object({
    status: TransactionStatusEnum.optional(),
    type: TransactionTypeEnum.optional(),
    user_uid: z.string().optional(),
    from_date: z.string().optional(),
    to_date: z.string().optional(),
    min_amount: z.number().optional(),
    max_amount: z.number().optional(),
});
// Earnings data for chart (monthly)
export const MonthlyEarningsSchema = z.object({
    month: z.string(), // "Jan", "Feb", etc.
    month_number: z.number(), // 1-12
    year: z.number(),
    earnings: z.number(),
    transactions_count: z.number(),
});
// Earnings summary
export const EarningsSummarySchema = z.object({
    total_earnings: z.number(),
    period_label: z.string(), // "This Month", "This Year", etc.
    period_start: z.date(),
    period_end: z.date(),
    previous_period_earnings: z.number(),
    change_percentage: z.number(),
    monthly_data: z.array(MonthlyEarningsSchema),
});
// Earnings by category
export const EarningsByCategorySchema = z.object({
    category: z.string(),
    course_id: z.number().nullable().optional(),
    earnings: z.number(),
    percentage: z.number(),
    transactions_count: z.number(),
    color: z.string().optional(),
});
// Earnings by category response
export const EarningsByCategoryResponseSchema = z.object({
    total_earnings: z.number(),
    categories: z.array(EarningsByCategorySchema),
});
// Orders summary
export const OrdersSummarySchema = z.object({
    total_orders: z.number(),
    previous_period_orders: z.number(),
    change_percentage: z.number(),
    period_label: z.string(),
});
// Transaction list response (paginated)
export const TransactionListResponseSchema = z.object({
    transactions: z.array(TransactionSchema),
    total: z.number(),
    page: z.number(),
    limit: z.number(),
    has_more: z.boolean(),
});
